import { Api } from "../api/api";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs/Observable";

import { AlertController } from "ionic-angular";

export interface TalkData {
  chat_room_id: number;
  free_text: string;
  image_url: string;
  gift_id: number;
  stamp_id: number;
}

@Injectable()
export class QualityCheckProvider {
  url: string = "quality_check";

  constructor(public api: Api, public alertCtrl: AlertController) {}

  createHistory(userId: number, toUserId: number): Observable<any> {
    return this.api.post(this.url + "_histories", {
      user_id: userId,
      to_user_id: toUserId,
    });
  }

  isShowedPointAlert(pointCallback: Function): void {
    let subtitle: string =
      "クオリティチェックを見るには15ポイントが必要です。ポイントを購入しますか？";
    const alert = this.alertCtrl.create({
      title: "ポイントが足りません",
      subTitle: subtitle,
      buttons: [
        {
          text: "はい",
          handler: () => {
            pointCallback();
          },
        },
      ],
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/quality-check/quality-check.ts